import { IMain } from "@/@types/servers/main-server";

export async function getRules(
  rusel: Array<IMain>,
  permitions: string[]
): Promise<Array<IMain>> {
  if (!rusel.length) return [];
  return rusel.filter((elServer) => {
    elServer.routes = elServer.routes.filter((elRoute) => {
      elRoute.methods = elRoute.methods.filter((elMethod) =>
        permitions.includes(elMethod.id)
      );
      return elRoute.methods.length ? elRoute : false;
    });
    return elServer.routes.length ? elServer : false;
  });
}
